import React, { useCallback, useEffect, useRef, useState } from "react"

const BOTTOM_SLACK_PX = 24

const HtmlContentFrame = ({ html, onBottomReached }) => {
  const frameRef = useRef(null)
  const reachedRef = useRef(false)
  const [height, setHeight] = useState(400)

  const markReached = useCallback(() => {
    if (reachedRef.current) return
    reachedRef.current = true
    onBottomReached?.()
  }, [onBottomReached])

  const check = useCallback(() => {
    const frame = frameRef.current
    if (!frame) return
    const rect = frame.getBoundingClientRect()
    if (rect.bottom <= window.innerHeight + BOTTOM_SLACK_PX) markReached()
  }, [markReached])

  useEffect(() => {
    reachedRef.current = false
  }, [html])

  useEffect(() => {
    const targets = [window]
    let el = frameRef.current?.parentElement
    while (el) {
      const overflow = getComputedStyle(el).overflowY
      if (overflow === "auto" || overflow === "scroll") targets.push(el)
      el = el.parentElement
    }
    targets.forEach((target) => target.addEventListener("scroll", check, { passive: true }))
    window.addEventListener("resize", check)
    return () => {
      targets.forEach((target) => target.removeEventListener("scroll", check))
      window.removeEventListener("resize", check)
    }
  }, [check])

  const handleLoad = () => {
    const doc = frameRef.current?.contentDocument
    if (doc?.documentElement) setHeight(doc.documentElement.scrollHeight + 16)
    requestAnimationFrame(check)
  }

  return (
    <iframe
      ref={frameRef}
      title="Must Read content"
      sandbox="allow-same-origin"
      srcDoc={html}
      onLoad={handleLoad}
      style={{ width: "100%", height, border: "1px solid #e5e9f0", borderRadius: 8, background: "#fff" }}
    />
  )
}

export default HtmlContentFrame
